import { isDefined } from "@opendaw/lib-std";
export var ExportConfiguration;
(function (ExportConfiguration) {
    ExportConfiguration.countStems = (config) => config.match({
        none: () => 1,
        some: cfg => isDefined(cfg.stems) ? Object.keys(cfg.stems).length : 1
    });
    ExportConfiguration.sanitizeFileName = (name) => name.replace(/[<>:"/\\|?*\x00-\x1F]/g, "_").trim();
    ExportConfiguration.sanitizeExportNamesInPlace = (configuration) => {
        if (!isDefined(configuration.stems)) {
            return;
        }
        const stems = configuration.stems;
        const sanitizedNames = new Map();
        const getUniqueName = (baseName) => {
            let count = sanitizedNames.get(baseName) ?? 0;
            let newName = baseName;
            while (sanitizedNames.has(newName)) {
                count++;
                newName = `${baseName} ${count}`;
            }
            sanitizedNames.set(baseName, count);
            sanitizedNames.set(newName, 1);
            return newName;
        };
        Object.keys(stems).forEach((key) => {
            const entry = stems[key];
            entry.fileName = getUniqueName(ExportConfiguration.sanitizeFileName(entry.fileName));
        });
    };
})(ExportConfiguration || (ExportConfiguration = {}));
